/**
 * Copyright 2021-2022 (c) Karsten Röthig, FVA GmbH (for umati and VDW e.V.)
 */
import * as React from 'react';
import { Component } from 'react';


export interface Props {
  columnHeaders: string[];
  data: any[][];
}

export interface State {
}

export default class Table extends Component<Props, State> {
  constructor (props : Props) {
    super(props);
    this.state = {};
  }

  render () {
    return (
      <table className="table table-bordered table-striped table-hover">
        <thead className="table-light">
          <tr>
            {this.props.columnHeaders.map((columnHeader, columnHeaderIndex) => (
              <th key={columnHeaderIndex}>{columnHeader}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {this.props.data.map((rowData, rowDataIndex) => (
            <tr key={rowDataIndex}>
              {rowData.map((columnData, columnDataIndex) => (
                <td key={columnDataIndex}>{columnData}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    );
  }
}
